// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2grSq","active":"active--CAtRy","bubbleContent":"bubbleContent--2Pjdb","mobileContent":"mobileContent--1OyZa"};